import { IndieTabletopClubLogo } from "@indietabletop/appkit";
import { Link } from "wouter";
import { m } from "../../messages.ts";
import climber from "./climber.png";
import { prompt } from "./style.css.ts";

export function JoinPrompt() {
  return (
    <div className={prompt.container}>
      <div className={prompt.infoContainer}>
        <div className={prompt.info}>
          {m.joinPromptDescription}
          <IndieTabletopClubLogo className={prompt.logo} />
        </div>
        <img src={climber} alt="" className={prompt.climber} />
      </div>
      <Link className={prompt.joinButton} href="/join">
        Join
      </Link>{" "}
      <Link className={prompt.loginButton} href="/login">
        log in
      </Link>
    </div>
  );
}
